















































import Vue from "vue";
import { Business } from "@/interfaces/business/business";
import { ENDPOINTS, get } from "@/api/mainApi";
import { Snackbar } from '@/interfaces/presentation/snackbar';
import { UserSession } from "@/interfaces/useraccount/userSession";
import { AuthRepository } from "@/repositories/authRepository";

export default Vue.extend({
  props: {
    dialogValue: Boolean,
    businesses: Array as () => Array<Business>,
  },
  data() {
    return {
      selectedBusinessId: 0 as number,
      authRepository: new AuthRepository(),
    }
  },
  computed: {
    active: {
      get(): boolean {
        return this.dialogValue
      },
      set(dialogValue: boolean) {
        this.$emit('update:dialogValue', dialogValue)
      }
    },
    sortedBusinesses(): Business[] {
      return [...this.businesses].sort((a, b) => a.name.localeCompare(b.name, 'sv', { sensitivity: 'base' }))
    },
  },
  methods: {
    async saved() {
      if (!this.selectedBusinessId) {
        return
      }
      if (this.$refs.form.validate()) {
        try {
          let userSession = await this.assumeUser()
          this.$emit('saved', userSession)
        } catch (err) {
          let snackbar: Snackbar = {
            active: true,
            color: "error",
            text: "Misslyckades att byta företag: " + JSON.stringify(err),
            timeout: 8000,
            action: null
          }
          this.$store.commit('setSnackbar', snackbar)
        }
          this.closeDialog()
      }
    },
    closeDialog() {
      this.active = false
    },
    async assumeUser(): Promise<UserSession> {
      return await this.authRepository.assumeBusinessUserRole(this.selectedBusinessId)
    },
  }
});
